import * as React from 'react';
import Svg, { G, Path } from 'react-native-svg';

import withIconWrapper from 'app/hocs/withIconWrapper';

export default withIconWrapper(function NoticeSuccess({ color, size, ...props }) {
  return (
    <Svg fill="none" height={size} viewBox="0 0 18 18" width={size} {...props}>
      <G>
        <Path
          d="M4.875 9.84081L6.55937 12.2312C6.62327 12.3267 6.70903 12.4055 6.80952 12.4611C6.91001 12.5167 7.02233 12.5475 7.13713 12.5509C7.25193 12.5543 7.36588 12.5303 7.46952 12.4808C7.57315 12.4313 7.66346 12.3578 7.73294 12.2663L13.125 5.44424"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.5}
        />
        <Path
          d="M1.26562 8.9993C1.26563 11.0506 2.08049 13.0179 3.53097 14.4683C4.98145 15.9188 6.94872 16.7337 9 16.7337C11.0513 16.7337 13.0186 15.9188 14.469 14.4683C15.9195 13.0179 16.7344 11.0506 16.7344 8.9993C16.7344 6.94801 15.9195 4.98075 14.469 3.53027C13.0186 2.07979 11.0513 1.26492 9 1.26492C6.94872 1.26492 4.98145 2.07979 3.53097 3.53027C2.08049 4.98075 1.26563 6.94801 1.26562 8.9993Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.5}
        />
      </G>
    </Svg>
  );
});
